export const PAGE_NOT_FOUND_CONSTANTS = {
  HEADING_TITLE: "Oops! Page not found.",
  DESC_SUBTITLE1: "We're sorry, but the page you are looking for cannot be found.",
  HOME_BUTTON_TEXT: " RETURN TO HOME PAGE",
};
